import {
  NtIdFormData,
  DropdownOption,
} from '../types/ntIdManagement.types';

type Props = {
  open: boolean;
  saving: boolean;
  isEdit: boolean;

  form: NtIdFormData;

  roles: DropdownOption[];
  statuses: DropdownOption[];
  teams: DropdownOption[];
  shifts: DropdownOption[];
  reportingManagers: DropdownOption[];

  onChange: (
    field: keyof NtIdFormData,
    value: string,
  ) => void;

  onClose: () => void;
  onSave: () => void;
};

const NtIdFormModal = ({
  open,
  saving,
  isEdit,
  form,
  roles,
  statuses,
  teams,
  shifts,
  reportingManagers,
  onChange,
  onClose,
  onSave,
}: Props) => {

  console.log("Modal roles", roles);
console.log("Modal shifts", shifts);
  if (!open) {
    return null;
  }

  const renderInput = (
    label: string,
    field: keyof NtIdFormData,
    value: string,
    placeholder: string,
    disabled = false,
  ) => (

    <div>

      <label className="mb-1 block text-xs font-medium text-gray-700">
        {label}
      </label>

      <input
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(field, e.target.value)}
        className="
          h-9
          w-full
          rounded-md
          border
          border-gray-300
          px-2
          text-xs
          placeholder:text-gray-400
          focus:border-violet-600
          focus:outline-none
          focus:ring-1
          focus:ring-violet-300
          disabled:bg-gray-100
        "
      />

    </div>

  );

  const renderSelect = (
    label: string,
    field: keyof NtIdFormData,
    value: string,
    options: DropdownOption[],
  ) => (

    <div>

      <label className="mb-1 block text-xs font-medium text-gray-700">
        {label}
      </label>

      <select
        value={value}
        onChange={(e) => onChange(field, e.target.value)}
        className="
          h-9
          w-full
          rounded-md
          border
          border-gray-300
          px-2
          text-xs
          text-gray-700
          focus:border-violet-600
          focus:outline-none
          focus:ring-1
          focus:ring-violet-300
        "
      >

        <option
          value=""
          disabled
        >
          Select {label}
        </option>

        {options.map((option) => (

          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>

        ))}

      </select>

    </div>

  );

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">

      <div className="w-full max-w-xl rounded-xl bg-white shadow-2xl">

        {/* Header */}

        <div className="flex items-center justify-between border-b px-5 py-3">

          <h2 className="text-base font-semibold text-gray-800">
            {isEdit ? 'Edit Employee' : 'Add Employee'}
          </h2>

          <button
            type="button"
            onClick={onClose}
            className="text-xl font-medium text-gray-500 hover:text-black"
          >
            ×
          </button>

        </div>

        {/* Body */}

        <div className="grid grid-cols-2 gap-3 p-5">

          {renderInput(
            'Employee Code',
            'employeeCode',
            form.employeeCode,
            'Enter employee code (Eg. SG123456)',
            isEdit,
          )}

          {renderInput(
            'Employee Name',
            'employeeName',
            form.employeeName,
            '',
            true,
          )}

          {renderInput(
            'Email',
            'email',
            form.email,
            '',
            true,
          )}

          {renderInput(
            'NT ID',
            'ntIds',
            form.ntIds,
            'Enter NT ID (Eg. Amit.Sharma)',
          )}

          {renderSelect(
            'Role',
            'role',
            form.role,
            roles,
          )}

          {/* {renderSelect(
            'Status',
            'status',
            form.status,
            statuses,
          )} */}

          <div>
  <label className="mb-1 block text-xs font-medium text-gray-700">
    Status
  </label>

  <select
    value={form.status}
    onChange={(e) => onChange('status', e.target.value)}
    className="
      h-9
      w-full
      rounded-md
      border
      border-gray-300
      px-2
      text-xs
      text-gray-700
      focus:border-violet-600
      focus:outline-none
      focus:ring-1
      focus:ring-violet-300
    "
  >
    <option value="">Select Status</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>
  </select>
</div>

          {/* {renderSelect(
            'Team',
            'team',
            form.team,
            teams,
          )} */}

          {renderSelect(
            'Shift',
            'shift',
            form.shift,
            shifts,
          )}

          {/* <div className="col-span-2">

            {renderSelect(
              'Reporting Manager',
              'reportingManager',
              form.reportingManager,
              reportingManagers,
            )} */}

          {/* </div> */}

          {/* Team */}

<div>

  <label className="mb-1 block text-xs font-medium">
    Team
  </label>

 <input
  type="text"
  value={form.team}
  disabled
  placeholder="Team"
  className="
    h-9
    w-full
    rounded-md
    border
    border-gray-300
    px-2
    text-xs
    bg-gray-100
    cursor-not-allowed
  "
/>

</div>

{/* Reporting Manager */}

<div>

  <label className="mb-1 block text-xs font-medium">
    Reporting Manager
  </label>

<input
  type="text"
  value={form.reportingManager}
  disabled
  placeholder="Reporting Manager"
  className="
    h-9
    w-full
    rounded-md
    border
    border-gray-300
    px-2
    text-xs
    bg-gray-100
    cursor-not-allowed
  "
/>

</div>

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-2 border-t px-5 py-3">

          <button
            type="button"
            onClick={onClose}
            className="
              rounded-md
              border
              border-gray-300
              px-4
              py-2
              text-xs
              font-medium
              hover:bg-gray-100
            "
          >
            Cancel
          </button>

          <button
            type="button"
            disabled={saving}
            onClick={onSave}
            className="
              rounded-md
              bg-violet-700
              px-4
              py-2
              text-xs
              font-medium
              text-white
              hover:bg-violet-800
              disabled:cursor-not-allowed
              disabled:opacity-60
            "
          >
            {saving
              ? 'Saving...'
              : isEdit
                ? 'Update'
                : 'Save'}
          </button>

        </div>

      </div>

    </div>

  );

};

export default NtIdFormModal;